<ng-container *ngIf="merchant.showLocationsMap; then detecting else default"></ng-container>
<ng-template #detecting>
  <app-home-locaion-detecting [restaurants]="restaurantStore.sortedRestaurants$ | async"
                              [merchant]="merchant"
                              [blackoutedDays]="blackoutedDays"
                              [merchantCatalog]="merchantCatalog"
                              [restaurantsDefault]="restaurantsDefault"
                              class="home-location-component">
  </app-home-locaion-detecting>
</ng-template>
<ng-template #default>
  <ion-header>
    <app-header [isHome]="isHome"
                [logo]="merchant.merchantLogo"
                [sourceBanner]="merchant.merchantBanner"
                [isCollapse]="!isScrollPositionTop"
                [merchantName]="merchant?.merchantName"
                [merchantHeaderTitle]="merchant?.merchantHeaderTitle"
                [merchantHeaderText]="merchant?.merchantHeaderText"
                pageName="merchant"
                hidePhoneIcon ="true">
      <div class="restaurants__wrapper">
        <button type="button"
                class="restaurants__top-button"
                [class.restaurants__top-button--is-colapse]="!isScrollPositionTop">
          Locations
        </button>
      </div>
    </app-header>
  </ion-header>
  <ion-content [scrollEvents]="true">
    <div class="container">
      <div class="select-category-wrap" *ngIf="merchant.categoryFilterEnabled">
        <select id="categorySelect" class="custom-select" [(ngModel)]="selectedCategory" (ngModelChange)="filterRestaurants($event)">
          <option [ngValue]="null">None</option>
          <option *ngFor="let catalog of merchantCatalog" [ngValue]="catalog.locationIds">
            {{ catalog.name }}
          </option>
        </select>
      </div>
      <div class="container__content restaurants">
        <div class="restaurants__restaurant-wrapper"
             *ngFor="let restaurant of restaurants; let index = index; let last = last">
          <div class="restaurants__restaurant card-wrap" (click)="goToRestaurantPage(restaurant)">
            <img
              *ngIf="!restaurant.isAcceptingOrders || !restaurant.isMobileEnabled || !isRestaurantHaveEnabledWorkDays(restaurant)"
              [src]="restaurantAllowScheduledOrders(restaurant) ? restaurantPreordersSign : restaurantClosedSign"
              class="restaurants__restaurant-closed-sign"
              [hidden]="isHideSigns(restaurant)"
              alt="restaurant closed sign"/>
            <img
              [src]="getLocationImage(restaurant)"
              class="restaurants__restaurant-image"
              alt="restaurant logo image"/>
            <ion-card-header class="restaurants__restaurant-header">
              <!--        <ion-card-subtitle>Card Subtitle</ion-card-subtitle>-->
              <ion-card-title class="restaurants__restaurant-title">{{restaurant.name}}
                <!--              TODO: uncomment a share icon latter-->
                <!--              <img class="restaurants__restaurant-share"-->
                <!--                   [src]="shareImageUrl"-->
                <!--                   alt="share icon"/>-->
              </ion-card-title>
            </ion-card-header>

            <ion-card-content class="restaurants__restaurant-content">
              <div (click)="$event.stopPropagation()">
                <ion-label>
                  <span class="restaurants__restaurant-detail-title">Address:&#160;</span>
                  <span class="restaurants__restaurant-detail-info">{{restaurant.address.addressLine}}
                    <img class="restaurants__restaurant-maps"
                         [src]="googleMapsImageUrl"
                         alt="g-maps icon"
                         (click)="openLocationInMaps(restaurant.address)"/>
              </span>
                </ion-label>
              </div>
              <div *ngIf="restaurant.contactPhoneNumber" (click)="$event.stopPropagation()">
                <ion-label>
                  <span class="restaurants__restaurant-detail-title">Phone:&#160;</span>
                  <span class="restaurants__restaurant-detail-info">
                  <a class="restaurants__restaurant-detail-phone-link" href="tel:{{formatPhoneNumber(restaurant.contactPhoneNumber, 'international')}}">{{formatPhoneNumber(restaurant.contactPhoneNumber, 'national')}}</a>
                </span>
                </ion-label>
              </div>
              <div *ngIf="restaurant.isShowHours">
                <ion-label>
                  <span class="restaurants__restaurant-address hours-wrap">
                    <span *ngIf="!restaurant.isMobileEnabled">Hours:&#160;Closed</span>
                    <span *ngIf="restaurant.isMobileEnabled" (click)="showHoursInfo(restaurant)">Hours:&#160;{{getDay(blackoutedDays[restaurant.locationId], 0)}}
                      <img class="restaurants__restaurant-triangle" [src]="restaurant.showHoursInfo ? arrowDown : arrowUp" alt="arrow-down icon"/>
                    </span>
                    <ul class="restaurants__restaurant-hours" *ngIf="restaurant.isMobileEnabled && restaurant.showHoursInfo" (click)="showHoursInfo(restaurant)">
                      <li *ngFor="let hours of restaurantWorkHours(restaurant); let i = index" [ngStyle]="{'font-weight': 'normal'}">
                        {{restaurantWorkDays(restaurant)[i] | titlecase}} {{hours}}
                      </li>
                    </ul>
                  </span>
                </ion-label>
              </div>
              <div *ngIf="restaurant.distance && restaurant.distance != -1 && restaurant.distance != true">
                <ion-label>
                  <span class="restaurants__restaurant-detail-title">Distance:&#160;</span>
                  <span class="restaurants__restaurant-detail-info">{{restaurant.distance}} miles away</span>
                </ion-label>
              </div>
              <div class="restaurants__restaurant-no-hours" *ngIf="!restaurant.isShowHours" ></div>
            </ion-card-content>
          </div>
        </div>
      </div>
    </div>
  </ion-content>
</ng-template>
